module.exports = __webpack_public_path__ + "./assets/img_kao_grey__f8840d52df661ba31d7801d45be3f480.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_kao_grey.jpg
// module id = 596
// module chunks = 12